import { Icon, type Props } from "./LikeIcon.Parts";

export const LikeIcon = ({ small, selected, ...props }: Props) => (
  <Icon
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    $small={small}
    {...props}
  >
    {selected ? (
      <path
        d="M18.5227 9.06956L16.4915 11.2063L10.307 17.7117C10.1371 17.8904 9.86244 17.8904 9.69318 17.7117L3.50799 11.2063L1.47685 9.06956C-0.492285 6.99741 -0.492285 3.62601 1.47685 1.55387C3.44661 -0.518282 6.65143 -0.517629 8.62056 1.55387L9.99946 3.00704L11.379 1.55387C13.3487 -0.517629 16.5529 -0.517629 18.5227 1.55387C20.4924 3.62601 20.4924 6.99741 18.5227 9.06956Z"
        fill="currentColor"
      />
    ) : (
      <path
        d="M8.46554 15.9585C8.34465 16.0857 8.34465 16.2924 8.46554 16.4196L9.69311 17.711C9.86298 17.8897 10.137 17.8897 10.3069 17.711L16.4912 11.2058L18.5223 9.06921C20.4926 6.99714 20.4926 3.62587 18.5223 1.55381C16.5532 -0.517609 13.3485 -0.517609 11.3795 1.55381L10 3.00693L8.62116 1.55381C6.6521 -0.517609 3.44741 -0.518261 1.47773 1.55381C-0.492576 3.62587 -0.492576 6.99714 1.47773 9.06921L3.50879 11.2058L6.27329 14.114C6.39418 14.2412 6.59072 14.2412 6.71162 14.114L8.0266 12.7307C8.14749 12.6035 8.14749 12.3968 8.0266 12.2696L3.23104 7.22476C2.22791 6.17014 2.22791 4.45418 3.23104 3.39956C4.23355 2.34494 5.86534 2.34494 6.86785 3.39956L10 6.69713L13.1321 3.39956C14.1353 2.34494 15.7665 2.34494 16.769 3.39956C17.7721 4.45418 17.7721 6.17014 16.769 7.22476L8.46554 15.9585Z"
        fill="currentColor"
      />
    )}
  </Icon>
);
